// ────────────────────────────────────────────────────────────────────────────
// Tipo de tenant (clínica / farmacéutica) y resolución de overrides.
//
// Objetivo: que un cambio propio de FARMA no toque nunca a CLÍNICA (base).
//   · Texto  → capa i18n: lengua "esFarma" = es + locales/es/farma.json
//              (ver services/i18n.js). No requiere tocar las vistas.
//   · Datos  → resolveByType(): cada JSON de vista puede llevar un bloque
//              opcional { "overrides": { "farma": { ...solo lo que cambia } } }.
//              La vista lee su dato con resolveByType(raw) y listo.
//
// Mientras los overrides estén vacíos, clínica y farma son idénticas.
// ────────────────────────────────────────────────────────────────────────────

export const TENANT_TYPES = ["clinica", "farma"];
export const DEFAULT_TENANT_TYPE = "clinica";

/** Tipo de tenant activo (lo fija el login en sessionStorage). */
export function getTenantType() {
    if (typeof window === "undefined") return DEFAULT_TENANT_TYPE;
    const t = sessionStorage.getItem("demoOrgType");
    return TENANT_TYPES.includes(t) ? t : DEFAULT_TENANT_TYPE;
}

/** Hook para leer el tipo dentro de un componente. */
export function useTenantType() {
    return getTenantType();
}

const isPlainObject = (v) => v && typeof v === "object" && !Array.isArray(v);

/** Merge profundo: el override gana; los arrays se reemplazan enteros. */
export function deepMerge(base, override) {
    if (!isPlainObject(base) || !isPlainObject(override)) return override;
    const out = { ...base };
    for (const key of Object.keys(override)) {
        out[key] = isPlainObject(base[key]) && isPlainObject(override[key])
            ? deepMerge(base[key], override[key])
            : override[key];
    }
    return out;
}

/**
 * Resuelve el dato de una vista según el tipo de tenant.
 * `base` puede incluir `overrides: { farma: {...} }`; se fusiona solo lo que
 * cambie para ese tipo y se elimina la clave `overrides` del resultado.
 */
export function resolveByType(base, type = getTenantType()) {
    if (!isPlainObject(base) || !isPlainObject(base.overrides)) return base;
    const { overrides, ...rest } = base;
    const ov = overrides[type];
    return isPlainObject(ov) ? deepMerge(rest, ov) : rest;
}
